/** Shared JSON array <-> ordered slide-id-list conversion between the picker and the review step. */

export function parseSlideIds(value: string): string[] {
  if (!value.trim()) return [];
  try {
    const parsed: unknown = JSON.parse(value);
    return Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === 'string' && id.length > 0) : [];
  } catch {
    return [];
  }
}

export function serializeSlideIds(ids: string[]): string {
  return ids.length === 0 ? '' : JSON.stringify(ids);
}
